import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbActiveModal, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { formatSiret } from 'src/app/core/helpers/utils';

@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  imports: [CommonModule, NgbModalModule],
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.scss'
})
export class ConfirmationModalComponent {
  @Input() title: string = 'Confirmation';
  @Input() message: string = 'Are you sure?';
  @Input() description: string = '';
  @Input() confirmButtonText: string = 'Ok';
  @Input() cancelButtonText: string = 'Cancel';
  @Input() confirmButtonClass: 'btn-danger' | 'btn-primary' = 'btn-danger';
  @Input() variant: 'default' | 'duplicate-warning' = 'default';
  @Input() duplicateType: string | null = null;
  @Input() duplicateMatches: any[] = [];

  formatSiret = formatSiret;

  constructor(
    public activeModal: NgbActiveModal,
    private sanitizer: DomSanitizer
  ) { }

  confirm() {
    this.activeModal.close(true);
  }

  cancel() {
    this.activeModal.dismiss(false);
  }

  safeHtml(message: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(message);
  }

  formatCreatedAt(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return '';
    }

    return new Intl.DateTimeFormat('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(date);
  }
}
